// extracted by mini-css-extract-plugin
export default {"examList":"ExamListShort_examList__V4Glf"};